module.exports = __webpack_public_path__ + "static/media/1-5.4e76e6ec.mp3";